import React from 'react';
export var TabsContext = /*#__PURE__*/React.createContext({
  isControlled: false,
  deselectable: false,
  hideActiveTab: function hideActiveTab() {
    return null;
  }
});
export var TabsContextProvider = TabsContext.Provider;